/**
 * Opens the transition message popup on load, every visit.
 *
 * Opens with the hash on purpose: body-controller makes the page inert while an
 * overlay hash is set, so Tab can't reach the page behind a locked popup.
 *
 * No consent gate yet. Also opens in the theme editor, so edits to its theme
 * settings show on reload.
 */
(function () {
  var OVERLAY_ID = 'transition-message-popup';

  function init() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    overlay.open();
  }

  // OverlayComponent inits on load; one frame later its container is in body.
  if (document.readyState === 'complete') {
    requestAnimationFrame(init);
  } else {
    window.addEventListener(
      'load',
      function () {
        requestAnimationFrame(init);
      },
      { once: true }
    );
  }
})();
